import { useState } from 'react';
import { testimonials } from '@/mocks/home';

export default function Testimonial() {
  const [current, setCurrent] = useState(0);
  const t = testimonials[current];

  const goNext = () => {
    setCurrent((prev) => (prev + 1) % testimonials.length);
  };

  const goPrev = () => {
    setCurrent((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-10 items-center">
            {/* Left Image */}
            <div className="w-full lg:w-[40%]">
              <div className="relative w-full aspect-square rounded-2xl overflow-hidden bg-accent-100">
                <img
                  src={t.imageUrl}
                  alt="百万瓜友的选择"
                  title="51吃瓜黑料用户口碑"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            {/* Right Content */}
            <div className="w-full lg:w-[60%]">
              <p className="text-foreground-400 font-label text-sm mb-4">
                （百万瓜友的选择）
              </p>
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-8 leading-tight">
                他们的真实评价
                <br />
                <span className="text-foreground-400">看看瓜友们怎么说</span>
              </h2>
              <blockquote className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8 max-w-lg">
                "{t.quote}"
              </blockquote>
              <div className="flex items-center gap-2 mb-8">
                <span className="w-8 h-0.5 bg-foreground-300"></span>
                <span className="font-heading font-semibold text-foreground-950 text-sm">
                  {t.author}
                </span>
                <span className="text-foreground-400 text-xs">· {t.role}</span>
              </div>

              {/* Nav Arrows */}
              <div className="flex items-center gap-3">
                <button
                  onClick={goPrev}
                  className="w-10 h-10 rounded-full border border-foreground-200 flex items-center justify-center text-foreground-500 hover:text-foreground-950 hover:border-foreground-400 transition-colors duration-200"
                  aria-label="上一条"
                >
                  <i className="ri-arrow-left-line"></i>
                </button>
                <button
                  onClick={goNext}
                  className="w-10 h-10 rounded-full bg-foreground-950 flex items-center justify-center text-background-50 hover:bg-foreground-800 transition-colors duration-200"
                  aria-label="下一条"
                >
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}